import type { CmpHider } from './types';

export const trustarc: CmpHider = {
  id: 'trustarc',
  label: 'TrustArc',
  css: `
      /* TrustArc (TrustArc/TRUSTe): the bottom consent banner bar lives in
         #consent_blackbar, which wraps the visible #truste-consent-track bar and
         its #trustarc-banner-overlay; hiding the blackbar removes the whole bar.
         #teconsent is the separate "Powered by TrustArc" link container that can
         render elsewhere on the page. The preferences modal renders in a nested
         iframe from consent.trustarc.com (.truste_overlay / .truste_popframe /
         .truste_popdiv) that does not load in the sandboxed preview, but we hide
         those selectors too in case a light-DOM build is used. TrustArc does not
         lock page scroll via a body class on the sites observed; if a build does,
         the html/html-body[style*="overflow"] release rule above already
         out-specifies an inline overflow lock. */
      #consent_blackbar,
      #truste-consent-track,
      #trustarc-banner-overlay,
      #teconsent,
      .truste_overlay,
      .truste_box_overlay,
      .truste_popframe,
      .truste_popdiv { display: none !important; }
  `,
};
